import styled from 'styled-components';

const SocialIcon = styled.i`
  color: white;
`;

export default SocialIcon;
